<template>
    <div class="menu" :class="{'menu--active' : active_here}">
        <button type="button" class="menu__close" aria-label="Закрыть меню" @click="closeMenu">
            <span class="menu__close-line"></span>
            <span class="menu__close-line"></span>
        </button>
        <ul class="menu__list">
            <!-- <li class="menu__item">
                <a href="#head1" class="menu__link" @click="anchor($event, 'head1')">
                    {{ $t('registry') }}  
                </a>
            </li> -->
            <li class="menu__item">
                <a href="#about" class="menu__link" @click="anchor($event, 'about')">
                    {{ $t('about_forum.title') }}  
                </a>
            </li>
            <li class="menu__item">
                <a href="#program" class="menu__link" @click="anchor($event, 'program')">
                    {{ $t('program') }}
                </a>
            </li>
            <li class="menu__item">
                <a href="#nomination" class="menu__link" @click="anchor($event, 'nomination')">
                    {{ $t('nomination.title') }}
                </a>
            </li>
            <li class="menu__item">
                <a href="#menti" class="menu__link" @click="anchor($event, 'menti')">
                    {{ $t('headers.mentoring') }}
                </a>
            </li>
            <li class="menu__item">
                <a href="#partners" class="menu__link" @click="anchor($event, 'partners')">
                    {{ $t('2026.footer.nav.partners') }}
                </a>
            </li>
            <li class="menu__item">
                <a href="#speakers" class="menu__link" @click="anchor($event, 'speakers')">
                    {{ $t('2026.footer.nav.speakers') }}
                </a>
            </li>
            <li class="menu__item">
                <a href="#reviews" class="menu__link" @click="anchor($event, 'reviews')">
                    {{ $t('2026.footer.nav.reviews') }}
                </a>
            </li>
            <li class="menu__item">
                <a href="#footer" class="menu__link" @click="anchor($event, 'footer')">
                    {{ $t('contacts') }}  
                </a>
            </li>
        </ul>
    </div>
</template>

<script scoped>
    import { smoothScrollTo } from "@/utils/smoothScroll";

    export default {
        name: 'ForumMenu',
        props: {
            active: {
                type: Boolean,
                require: true,
            }
        },
        data() {
            return {
                active_here: false,
            }
        },
        watch: {
            active(value) {
                this.active_here = value;
            }
        },
        methods: {
            closeMenu() {
                this.$emit('closeMenu', false);
                this.active_here = false;
            },
            anchor(event, blockID) {
                event.preventDefault();

                const targetElement = document.getElementById(blockID);

                if (targetElement) {
                    smoothScrollTo(targetElement.offsetTop - 100);
                }
                this.closeMenu();
            },
        }

    }
</script>

<style lang="scss" scoped>
.menu {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    min-height: 100dvh;
    background-color: #000;
    z-index: 100;
    transform: translateY(-100%);
    transition: transform 300ms ease-in-out;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &--active {
        transform: translateY(0);
    }

    &__close {
        position: absolute;
        top: max(24px, env(safe-area-inset-top));
        right: max(24px, env(safe-area-inset-right));
        width: 40px;
        height: 40px;
        padding: 0;
        border: none;
        background: transparent;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
    }

    &__close-line {
        position: absolute;
        width: 24px;
        height: 3px;
        border-radius: 2px;
        background-color: #fff;
        &:nth-child(1) {
            transform: rotate(45deg);
        }
        &:nth-child(2) {
            transform: rotate(-45deg);
        }
    }

    &__list {
        color: #fff;
        text-align: center;
        padding: 0;
        list-style: none;
    }

    &__item {
        margin-bottom: clamp(16px, 4vw, 24px);
    }

    &__link {
        font-size: clamp(16px, 2.5vw + 14px, 22px);
        line-height: 1.3;
        color: inherit;
        text-decoration: none;
        text-transform: uppercase;
    }
}
</style>